import axios from "axios";
import {
  MDBCol,
  MDBInput,
  MDBRow,
  MDBTextArea,
} from "mdb-react-ui-kit";
import React, {
  useState,
  useEffect,
  useRef,
  useContext,
  useImperativeHandle,
  forwardRef,
} from "react";
import { Form } from "react-bootstrap";
import Alerts from "../Alerts";
import URLAPI from "../../helpers/Path";
import "../../styles/newpf.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import ReactDOM from "react-dom";
import { useParams } from "react-router-dom";
import tache from "../../assets/TACHE NOTARIA.png";
import { UsuarioContext } from "../context/UsuarioContext.jsx";
import { useUsuarioStore } from "../zustandShared/usuarioStore.js";

const New = (props) => {
  //Obtener el id de la url
  const { id_user } = useParams();

  //Usamos useContext solamente cuando New se va a usar como componente para otros apartados de la pagina, sino automaticamente se mandara como null
  const { abrirNuevo, setAbrirNuevo } = useContext(UsuarioContext) || {};

  const {
    agregarAdquiriente,
    agregarOtorgante,
    boolAdquiriente,
    boolOtorgante,
    setCerrarModal,
  } = useUsuarioStore(); //Estos apartados se usan para lo mismo de lo anterior
  // -------------------------------------------------------------------------------------------------------------------------------------
  const deleteAdquiriente = useUsuarioStore((state) => state.deleteAdquiriente);

  useEffect(() => {
    deleteAdquiriente();
  }, []);
      const deleteOtorgante = useUsuarioStore(
    (state) => state.deleteOtorgante
  );



  //traigo los catalogos de nacionalidad, estado civil, regimen civil y regimen fiscal
  const id_nacionalidadPhp = URLAPI + "lista_nacionalidad.php";
  const id_estadoPhp = URLAPI + "lista_estado.php";
  const id_regimenPhp = URLAPI + "lista_regimen.php";
  const id_regimen_fiscalPhp = URLAPI + "lista_regimen_fiscal.php";
  const id_lista_paisPhp = URLAPI + "lista_pais.php";
  // ---------------------------------------------------------------------------------------------------------------------------

  // Bool para que el evento no se ejecute el doble si el usuario le presiona mientras se esta concluyendo el evento en un boton
  const [loading, setLoading ] = useState(false);
  // -------------------------------------------------------------------------------------------------------------------------
  // Contiene la ventana emergente
  const poparchivosURL = URLAPI + "poparchivos.php";
  // --------------------------------------------------------------------------------------------------
  // Trae todos los archivos que se han guardado anteriormente
  const tempo_archivos = URLAPI + "tempo_archivos.php";
  // -----------------------------------------------------------------------------------------------------------------

  //Todo del modal de guarda archivos ---------------------------------------------------------------------------------
  //Variable de estado para insertar html crudo.
  const [modalHTML, setModalHTML] = useState("");
  //Borrar archivos
  const borra_archivo = URLAPI + "borra_archivo.php";
  // URL post API PHP para guardar el cliente
  const urlPhp = URLAPI + "guarda_cliente.php";
  // Configuración del modal para guardar archivos
  const [showModal, setShowModal] = useState(false);
  // --------------------------------------------------------------------------------------------------------------

  // Data Create natural person

  const [nombre, setnombre] = useState("");
  const [ap_paterno, setap_paterno] = useState("");
  const [ap_materno, setap_materno] = useState("");
  const [tambien_conocido, settambien_conocido] = useState("");
  const [nacionalidades, setnacionalidades] = useState([]);
  const [id_nacionalidad, setid_nacionalidad] = useState(0);
  const [lugar_nacimiento, setlugar_nacimiento] = useState("");
  const [fecha_nacimiento, setfecha_nacimiento] = useState(null);
  const [ocupacion, setocupacion] = useState("");
  const [curp, setcurp] = useState("");
  const [rfcphysics, setrfcphysics] = useState("");
  const [rfclegalentity, setrfclegalentity] = useState("");
  const [estados, setestados] = useState([]);
  const [id_estado, setid_estado] = useState(0);
  const [regimenes, setregimenes] = useState([]);
  const [id_regimen, setid_regimen] = useState(0);
  const [regimenes_fiscales, setregimenes_fiscales] = useState([]);
  const [id_regimen_fiscal, setid_regimen_fiscal] = useState(0);

  // Data Create moral person

  const [razon_social, setrazon_social] = useState("");
  const [representante_legal, setrepresentante_legal] = useState("");
  const [rfc_moral, setrfc_moral] = useState("");

  // Domicilio

  const [calle, setCalle] = useState("");
  const [no_exterior, setNoExterior] = useState("");
  const [no_interior, setNoInterior] = useState("");
  const [colonia, setColonia] = useState("");
  const [localidad, setLocalidad] = useState("");
  const [ciudad, setCiudad] = useState("");
  const [estado, setEstado] = useState("");
  const [pais, setPais] = useState("");
  const [paises, setPaises] = useState([]);
  const [id_pais, setid_pais] = useState(0);
  const [cp, setCp] = useState("");

  //Contacto

  const [telefono_particular, setTelefonoParticular] = useState("");
  const [telefono_oficina, setTelefonoOficina] = useState("");
  const [telefono_movil, setTelefonoMovil] = useState("");
  const [correo_electronico, setCorreoElectronico] = useState("");
  const [observaciones_generales, setObservacionesGenerales] = useState("");

  //Objeto para guardar las fechas de vigencia
  const [fechas, setFechas] = useState({});

  //Archivos desplegados
  const [archive, setArchive] = useState([]);

  // Messages
  const [msgError, setMsgError] = useState("");

  // Alert de error y cuando se logra enviar el archivo
  const [isAlert, setIsAlert] = useState(false);
  const [isAlert2, setIsAlert2] = useState(false);

  // Page que servira para recargar la pagina
  const [isCreated, setIsCreated] = useState(false);

  // Seleccionar persona fisica o personal moral según el radiobutton
  const [selectedOption, setSelectedOption] = useState("1"); // "1" para persona física, "2" para persona moral

  //Iluminar errores del registro -------------------------------------------------------------------------------
  // Referencias para persona física
  const nombreRef = useRef(null);
  const ap_paternoRef = useRef(null);
  const ap_maternoRef = useRef(null);
  const tambien_conocidoRef = useRef(null);
  const id_nacionalidadRef = useRef(null);
  const lugar_nacimientoRef = useRef(null);
  const fecha_nacimientoRef = useRef(null);
  const ocupacionRef = useRef(null);
  const curpRef = useRef(null);
  const rfcRef = useRef(null);
  const id_estadoRef = useRef(null);
  const id_regimenRef = useRef(null);

  // Referencias para persona moral
  const razon_socialRef = useRef(null);
  const representante_legalRef = useRef(null);
  const rfc_moralRef = useRef(null);
  const archivo_fecharef = useRef(null);

  // Referencias domicilio
  const calleRef = useRef(null);
  const no_exteriorRef = useRef(null);
  const coloniaRef = useRef(null);
  const localidadRef = useRef(null);
  const ciudadRef = useRef(null);
  const estadoRef = useRef(null);
  const id_paisRef = useRef(null);
  const cpRef = useRef(null);
  // Referencias contacto
  const telefono_movilRef = useRef(null);
  const correo_electronicoRef = useRef(null);

  const customInputRef = useRef(null);

  // -------------------------------------------------------------------------------------------------------------

  //Expresiones reguladas
  const curpRegex =
    /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/;

  const rfcRegexphysics =
    /^([A-ZÑ&]{4}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

  const rfcRegexlegalentity =
    /^([A-ZÑ&]{3}) ?(?:- ?)?(\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])) ?(?:- ?)?([A-Z\d]{2})([A\d])$/;

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  // --------------------------------------------------------------------------------------------------------------



  //Boton para cerrar modal a traves del prop solamente cuando se esta usando New como componente externo
  const cerrar_Modal = () => {
    setCerrarModal(false);
    setAbrirNuevo(false);
  };
  //-----------------------------------------------------------------------------------------------------------

  // Configuración y diseño para que no se pueda ingresar ningun texto al imput de selecciona tu fecha de nacimiento
  const CustomDateInput = forwardRef(({ value, onClick }, ref) => {
    //console.log("Rendering CustomDateInput");
    const internalRef = useRef(null);

    useImperativeHandle(ref, () => ({
      focus: () => {
        //console.log("Focusing input");
        internalRef.current?.focus();
      },
      highlight: () => {
        //console.log("Highlighting input");
        if (!internalRef.current) return;
        internalRef.current.classList.add("highlight-input");
        setTimeout(() => {
          internalRef.current.classList.remove("highlight-input");
        }, 2000);
      },
    }));

    return (
      <div className="position-relative w-100">
        <input
          type="text"
          ref={internalRef}
          value={value}
          readOnly
          placeholder="Selecciona tu fecha de nacimiento"
          className="form-control pe-5"
          onClick={onClick}
        />
        <button
          type="button"
          onClick={onClick}
          className="btn btn-warning position-absolute top-50 end-0 translate-middle-y me-1 d-flex align-items-center gap-1"
          style={{ borderRadius: "8px", fontWeight: "bold" }}
        >
          <i className="fas fa-caret-down"></i>
        </button>
      </div>
    );
  });
  //-------------------------------------------------------------------------------------------------------------------

  //Función que se ejecuta cuando se quiere borrar un archivo directamente a traves del boton de la "x"
  const delete_files = async (archivo) => {
    try {
      const res = await axios.post(
        `${borra_archivo}?file_name=${archivo}&id_user=${id_user}`
      );

      if (res) {
        // Eliminar archivo del array
        setArchive((prev) => prev.filter((f) => f !== archivo));

        // Eliminar la fecha asociada al archivo
        setFechas((prevFechas) => {
          const newFechas = { ...prevFechas };
          delete newFechas[archivo]; // eliminar usando el nombre del archivo
          return newFechas;
        });

        //console.log(res);
      }
    } catch (error) {
      //console.log("No se logró borrar el archivo", error);
    }
  };
  // -------------------------------------------------------------------------------------------------------------

  //Función para iluminar el input de fecha
  const focusAndHighlightdate = () => {
    //console.log("linea enfocada");
    if (!customInputRef.current) return;

    // Llamamos los métodos expuestos por useImperativeHandle
    customInputRef.current.focus();
    customInputRef.current.highlight();
  };
  // ----------------------------------------------------------------------------------------------------------

  //Función para iluminar los input en general
  const focusAndHighlight = (inputRef) => {
    if (!inputRef?.current) return;

    inputRef.current.focus();
    const originalBorder = inputRef.current.style.border;
    const originalBackground = inputRef.current.style.backgroundColor;

    // Resaltar con borde rojo y fondo ligeramente rosado
    inputRef.current.style.border = "2px solid red";
    inputRef.current.style.backgroundColor = "#ffe6e6";

    setTimeout(() => {
      inputRef.current.style.border = originalBorder;
      inputRef.current.style.backgroundColor = originalBackground;
    }, 2000); // 2 segundos
  };
  // ------------------------------------------------------------------------------------------------------

  // Este useffect se encarga de mostrar la ventana emergente hecha en html que se obtiene a traves del servidor php, cuando se cierra se manda a llamar a los archivos que estaban guardados en terminacion f
  useEffect(() => {
    if (showModal) {
      var caracteristicas = "left=150, top=50, width=750, height=440";
      const popup = window.open(
        `${poparchivosURL}?id_user=${id_user}`,
        "",
        caracteristicas
      );

      //console.log("variable que desconosco", popup.caracteristicas)

      const timer = setInterval(async () => {
        if (popup && popup.closed) {
          clearInterval(timer);
          //alert("La ventana esta cerrada");
          try {
            const res = await axios.post(
              `${tempo_archivos}?id_user=${id_user}`
            );

            //Verifica que no se suba ningun archivo con el mismo nombre
            const archivosExistentes = res.data;
            const archivossinrepetir = [...new Set(archivosExistentes)];

            const archivosNuevos = [];

            archivossinrepetir.forEach((file) => {
              const archivo_repetido = archive.find(
                (item) => item.nombre === file,
              );
              if (!archivo_repetido) {
                archivosNuevos.push(file);
              }
            });


            //console.log(res.data);
            setArchive(archivosNuevos);

            
          } catch (error) {
            console.log("Error al subir los archivos", error);
          }
        }
      }, 500);
      setShowModal(false);
      /*const modal = document.querySelector(".modal");
      if (modal && window.bootstrap) {
        const bootstrapModal = new window.bootstrap.Modal(modal);
        bootstrapModal.show();
      }*/
    }
  }, [showModal]);
  // ---------------------------------------------------------------------------------------------------------



  //Este codigo se encarga de hacer una petición para llamar a la ventana emergente
  const handleOpenModal = async () => {
    try {
      const res = await axios.get(poparchivosURL);
      //setModalHTML(res.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error al cargar el modal:", error);
    }
  };
  // -------------------------------------------------------------------------------------------------

  //Este codigo se encarga de cerrar la ventana emergente

  const handleCloseModal = () => {
    setShowModal(false);
  };
  // ------------------------------------------------------------------------------------------------------


  //Funciónes que determinan cual input tiene el error y lo ilumina
  const getRefFromErrordate = () => {
    switch (msgError) {
      case "Campo de fecha de nacimiento vacío":
        //console.log("fecha ha sido seleccionado")
        return fecha_nacimientoRef;
    }
  };
  const getRefFromError = () => {
    switch (msgError) {
      // Persona física
      case "Campo Nombre vacío":
        return nombreRef;
      case "Campo de apellido paterno vacío":
        return ap_paternoRef;
      case "Campo de apellido materno vacío":
        return ap_maternoRef;
      case "Campo de también conocido como se encuentra vacío":
        return tambien_conocidoRef;
      case "Campo de nacionalidad no seleccionado":
        return id_nacionalidadRef;

      case "Campo de lugar de nacimiento vacío":
        return lugar_nacimientoRef;
      case "Campo de ocupación vacío":
        return ocupacionRef;
      case "Campo de C.U.R.P. vacio":
      case "C.U.R.P. inválido":
        return curpRef;
      case "Campo de R.F.C. vacío":
      case "RFC inválido":
        return rfcRef;
      case "Campo de estado civil no seleccionado":
        return id_estadoRef;
      case "Campo de régimen civil no seleccionado":
        return id_regimenRef;

      // Persona moral
      case "Campo de razón social vacío":
        return razon_socialRef;
      case "Campo de representante legal vacío":
        return representante_legalRef;
      case "Campo de RFC moral vacío":
        return rfc_moralRef;
      case "RFC moral inválido":
        return rfc_moralRef;
      //Archivos
      /* case "Campos de vigencia vacios":
        return archivo_fecharef;*/

      // Domicilio
      case "Campo de calle vacío":
        return calleRef;
      case "Campo de No. exterior vacío":
        return no_exteriorRef;
      case "Campo de colonia vacío":
        return coloniaRef;
      case "Campo de localidad vacío":
        return localidadRef;
      case "Campo de ciudad vacío":
        return ciudadRef;
      case "Campo de estado vacío":
        return estadoRef;
      case "Campo de país no seleccionado":
        return id_paisRef;
      case "Campo de CP vacío":
        return cpRef;
      case "El campo de CP solo acepta números":
        return cpRef;

      // Contacto
      case "Campo de teléfono móvil vacío":
        return telefono_movilRef;
      case "Campo de correo electrónico está vacío":
      case "Correo electronico inválido":
        return correo_electronicoRef;

      default:
        return null; // Si no hay match
    }
  };

  // ----------------------------------------------------------------------------------------------------

  //Aplicamos un cambio de nombre para cuando el estado civil se seleccione como "Casado"
  /*const regimenesChangeName = useMemo(() => {
    const estadoNum = Number(id_estado); // convierte a número
    if (estadoNum === 1) {
      return "Selecciona el régimen matrimonial";
    } else {
      return "Selecciona el régimen civil";
    }
  }, [id_estado, regimenes]);

  // const navigate = useNavigate();

  /* const selectData = useMemo(
        () => [
            { text: "Seleccionar tipo de usuario", value: 0 },
            { text: "Administrador", value: 1 },
            { text: "Supervisor", value: 2 },
            { text: "Auxiliar", value: 3 },
        ],
        []
    );

    const handleSelectChange = (e) => {
        setid_nacionalidad(parseInt(e.target.value));
    };*/


  //Funciones que determinan el guardado de los enlistados del formulario
  const handleChangeid_nacionalidad = (e) => {
    const nacionalidad = parseInt(e.target.value);
    setid_nacionalidad(nacionalidad);
  };

  const handleChangeid_estado = (e) => {
    const value = e.target.value;
    if (value === "") {
      setid_estado(0); // vacío permitido
      setid_regimen(0); // reseteamos régimen también
    } else {
      const estado = parseInt(value);
      setid_estado(estado);
      if (estado !== 1) {
        setid_regimen(0); // reseteamos si no es casado
      }
    }
  };

  const handleChangeid_regimen = (e) => {
    const regimen = parseInt(e.target.value);
    //setid_regimen(regimen);
    //console.log("regimen", regimen)
    setid_regimen(Number.isNaN(regimen) ? 0 : regimen);
  };

  const handleChangeid_regimen_fiscal = (e) => {
    const regimen_fiscal = parseInt(e.target.value);
    setid_regimen_fiscal(regimen_fiscal);
  };

  const handleChangePais = (e) => {
    setid_pais(e.target.value);
  };

  // --------------------------------------------------------------------------------------------------

  // Funciones que determinan cuando cambia un input y a traves de esto si esta vacio o no
  const handleInputChange = (e, type, fileName) => {
    switch (type) {
      // Persona física
      case "nombre":
        setMsgError("");
        setnombre(e.target.value);
        if (e.target.value === "") setMsgError("Campo Nombre vacío");
        else setIsAlert(false)
        break;

      case "ap_paterno":
        setMsgError("");
        setap_paterno(e.target.value);
        if (e.target.value === "")
          setMsgError("Campo de apellido paterno vacío");
        else setIsAlert(false)
        break;

      case "ap_materno":
        setMsgError("");
        setap_materno(e.target.value);
        if (e.target.value === "")
          setMsgError("Campo de apellido materno vacío");
        else setIsAlert(false)
        break;

      case "tambien_conocido":
        setMsgError("");
        settambien_conocido(e.target.value);
        if (e.target.value === "")
          setMsgError("Campo de también conocido como se encuentra vacío");
        else setIsAlert(false)
        break;

      case "id_nacionalidad":
        setMsgError("");
        const valor = parseInt(e.target.value);
        setid_nacionalidad(valor);
        if (valor === 0) setMsgError("Campo de nacionalidad no seleccionado");
        else setIsAlert(false)
        break;

      case "fecha_nacimiento":
        setMsgError("");
        setfecha_nacimiento(e.target.value);
        if (e.target.value === "")
          setMsgError("Campo de fecha de nacimiento vacío");
        else setIsAlert(false)
        break;

      case "lugar_nacimiento":
        setMsgError("");
        setlugar_nacimiento(e.target.value);
        if (e.target.value === "")
          setMsgError("Campo de lugar de nacimiento vacío");
        else setIsAlert(false)
        break;

      case "ocupacion":
        setMsgError("");
        setocupacion(e.target.value);
        if (e.target.value === "") setMsgError("Campo de ocupación vacío");
        else setIsAlert(false)
        break;

      case "curp":
        setMsgError("");
        setcurp(e.target.value);
        if (e.target.value === "") setMsgError("Campo de C.U.R.P. vacio");
        else if (!curpRegex.test(e.target.value.toUpperCase()))
          setMsgError("C.U.R.P. inválido");
        else setIsAlert(false)
        break;

      case "rfc":
        setMsgError("");
        setrfcphysics(e.target.value);
        const rfcLimpio = e.target.value.trim().toUpperCase();
        if (rfcLimpio === "") setMsgError("Campo de R.F.C. vacío");
        else if (!rfcRegexphysics.test(rfcLimpio)) setMsgError("RFC inválido");
        else setIsAlert(false)
        break;

      case "id_estado":
        setMsgError("");
        setid_estado(parseInt(e.target.value));
        if (e.target.value === 0)
          setMsgError("Campo de estado civil no seleccionado");
        else setIsAlert(false)
        break;

      case "id_regimen":
        setMsgError("");
        setid_regimen(parseInt(e.target.value));
        if (e.target.value === 0)
          setMsgError("Campo de régimen civil no seleccionado");
        else setIsAlert(false)
        break;

      case "telefono_particular":
        setMsgError("");
        setTelefonoParticular(e.target.value);
        break;

      case "telefono_oficina":
        setMsgError("");
        setTelefonoOficina(e.target.value);
        break;

      case "observaciones_generales":
        setMsgError("");
        setObservacionesGenerales(e.target.value);
        break;

      case "no_interior":
        setMsgError("");
        setNoInterior(e.target.value);
        break;

      // Persona moral
      case "razon_social":
        setMsgError("");
        setrazon_social(e.target.value);
        if (e.target.value === "") setMsgError("Campo de razón social vacío");
        else setIsAlert(false)
        break;

      case "representante_legal":
        setMsgError("");
        setrepresentante_legal(e.target.value);
        if (e.target.value === "")
          setMsgError("Campo de representante legal vacío");
        else setIsAlert(false)
        break;

      case "rfc_moral":
        setMsgError("");
        setrfc_moral(e.target.value);
        const rfcMoralLimpio = e.target.value.trim().toUpperCase();
        if (rfcMoralLimpio === "") setMsgError("Campo de RFC moral vacío");
        else if (!rfcRegexlegalentity.test(rfcMoralLimpio))
          setMsgError("RFC moral inválido");
        else setIsAlert(false)
        break;

      case "archivo_fecha":
        setMsgError("");
        if (!e.target.value) {
          setMsgError("Algunos o todos los campos de vigencia están vacíos");
          setIsAlert(true);
        } else {
          const selectedDate = new Date(e.target.value);
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          if (selectedDate < today) {
            setMsgError(
              "La fecha de vigencia no puede ser menor al día de hoy"
            );
            setIsAlert(true);
          } else {
            setFechas((prev) => ({
              ...prev,
              [fileName]: e.target.value,
            }));
          }
        }
        break;

      // Domicilio
      case "calle":
        setMsgError("");
        setCalle(e.target.value);
        if (e.target.value === "") setMsgError("Campo de calle vacío");
        else setIsAlert(false)
        break;

      case "no_exterior":
        setMsgError("");
        setNoExterior(e.target.value);
        if (e.target.value === "") setMsgError("Campo de No. exterior vacío");
        else setIsAlert(false)
        break;

      case "colonia":
        setMsgError("");
        setColonia(e.target.value);
        if (e.target.value === "") setMsgError("Campo de colonia vacío");
        else setIsAlert(false)
        break;

      case "localidad":
        setMsgError("");
        setLocalidad(e.target.value);
        if (e.target.value === "") setMsgError("Campo de localidad vacío");
        else setIsAlert(false)
        break;

      case "ciudad":
        setMsgError("");
        setCiudad(e.target.value);
        if (e.target.value === "") setMsgError("Campo de ciudad vacío");
        else setIsAlert(false)
        break;

      case "estado":
        setMsgError("");
        setEstado(e.target.value);
        if (e.target.value === "") setMsgError("Campo de estado vacío");
        else setIsAlert(false)
        break;

      case "pais":
        setMsgError("");
        const pais = parseInt(e.target.value);
        setid_nacionalidad(pais);
        if (pais === 0) setMsgError("Campo de país no seleccionado");
        else setIsAlert(false)
        break;

      case "cp":
        setCp(e.target.value);
        setMsgError(""); // Limpiar mensaje de error

        if (e.target.value === "") {
          setMsgError("Campo de CP vacío");
        } else if (!/^\d*$/.test(e.target.value)) {
          setMsgError("El campo de CP solo acepta números");
        }
        else setIsAlert(false)
        break;

      // Contacto
      case "telefono_movil":
        setMsgError("");
        setTelefonoMovil(e.target.value);
        if (e.target.value === "") setMsgError("Campo de teléfono móvil vacío");
        else setIsAlert(false)
        break;

      case "correo_electronico":
        setMsgError("");
        setCorreoElectronico(e.target.value);
        if (e.target.value === "")
          setMsgError("Campo de correo electrónico está vacío");
        else if (!emailRegex.test(e.target.value.toUpperCase()))
          setMsgError("Correo electronico inválido");
        else setIsAlert(false)
        break;
    }
  };

  // ------------------------------------------------------------------------------------------------



  // Funcion que hace una validacion del formulario antes de subirse

  const validateData = () => {
    if (selectedOption === "1") {
      // Persona física
      if (nombre.trim() === "") return "Campo Nombre vacío";
      if (ap_paterno.trim() === "") return "Campo de apellido paterno vacío";
      if (ap_materno.trim() === "") return "Campo de apellido materno vacío";
      if (tambien_conocido.trim() === "")
        return "Campo de también conocido como se encuentra vacío";
      if (id_nacionalidad === 0) return "Campo de nacionalidad no seleccionado";
      if (!fecha_nacimiento || String(fecha_nacimiento).trim() === "")
        return "Campo de fecha de nacimiento vacío";
      if (lugar_nacimiento.trim() === "")
        return "Campo de lugar de nacimiento vacío";
      if (ocupacion.trim() === "") return "Campo de ocupación vacío";
      if (curp.trim() === "") return "Campo de C.U.R.P. vacio";
      if (!curpRegex.test(curp.toUpperCase())) return "C.U.R.P. inválido";
      if (rfcphysics.trim() === "") return "Campo de R.F.C. vacío";
      if (!rfcRegexphysics.test(rfcphysics.toUpperCase()))
        return "RFC inválido";
      if (id_estado === 0) return "Campo de estado civil no seleccionado";
      if (id_estado === 1 && id_regimen === 0)
        return "Campo de régimen civil no seleccionado";

      // Domicilio
      if (calle.trim() === "") return "Campo de calle vacío";
      if (no_exterior.trim() === "") return "Campo de No. exterior vacío";
      if (colonia.trim() === "") return "Campo de colonia vacío";
      if (localidad.trim() === "") return "Campo de localidad vacío";
      if (ciudad.trim() === "") return "Campo de ciudad vacío";
      if (id_pais === 0) return "Campo de país no seleccionado";
      if (estado.trim() === "") return "Campo de estado vacío";
      if (cp.trim() === "") return "Campo de CP vacío";
      //Solo numeros en cp
      const cpRegex = /^\d+$/;
      if (!cpRegex.test(cp)) return "El campo de CP solo acepta números";

      // Contacto
      if (telefono_movil.trim() === "") return "Campo de teléfono móvil vacío";
      if (correo_electronico.trim() === "")
        return "Campo de correo electrónico está vacío";
      if (!emailRegex.test(correo_electronico.toUpperCase()))
        return "Correo electronico inválido";
    } else if (selectedOption === "2") {
      // Persona moral
      if (razon_social.trim() === "") return "Campo de razón social vacío";
      if (representante_legal.trim() === "")
        return "Campo de representante legal vacío";
      if (rfc_moral.trim() === "") return "Campo de RFC moral vacío";
      if (!rfcRegexlegalentity.test(rfc_moral.toUpperCase()))
        return "RFC moral inválido";

      // Domicilio
      if (calle.trim() === "") return "Campo de calle vacío";
      if (no_exterior.trim() === "") return "Campo de No. exterior vacío";
      if (colonia.trim() === "") return "Campo de colonia vacío";
      if (localidad.trim() === "") return "Campo de localidad vacío";
      if (ciudad.trim() === "") return "Campo de ciudad vacío";
      if (id_pais === 0) return "Campo de país no seleccionado";
      if (estado.trim() === "") return "Campo de estado vacío";
      if (cp.trim() === "") return "Campo de CP vacío";

      // Contacto
      if (telefono_movil.trim() === "") return "Campo de teléfono móvil vacío";
      if (correo_electronico.trim() === "")
        return "Campo de correo electrónico está vacío";
      if (!emailRegex.test(correo_electronico.toUpperCase()))
        return "Correo electronico inválido";
    }

    return "";
  };

  // -------------------------------------------------------------------------------------------------------

  // Funcion que se usa par recargar la pagina cuando se aparece el alert de guardado exitoso

  useEffect(() => {
    if (isCreated) {
      window.location.reload();
    }
  }, [isCreated]);

  // --------------------------------------------------------------------------------------------------------
   
  // Funcion para subir el formulario

  const handleSubmitData = async (e) => {
    
    if (selectedOption === "1") { // si es 1, sera persona fisica
      const validationMsg = validateData();

      if (validationMsg !== "") {
        setIsAlert(true);
        setMsgError(validationMsg);
        return; // No enviar si hay errores
      }
      if (
        //Persona fisica

        nombre !== "" &&
        ap_paterno !== "" &&
        ap_materno !== "" &&
        tambien_conocido !== "" &&
        id_nacionalidad !== 0 &&
        id_nacionalidad !== undefined &&
        lugar_nacimiento !== "" &&
        fecha_nacimiento !== "" &&
        ocupacion !== "" &&
        curp !== "" &&
        rfcphysics !== "" &&
        id_estado !== "" &&
        id_estado !== 0 &&
        (id_estado !== 1 || id_regimen !== 0) &&
        //Domicilio
        calle !== "" &&
        no_exterior !== "" &&
        colonia !== "" &&
        localidad !== "" &&
        ciudad !== "" &&
        estado !== "" &&
        id_pais !== 0 &&
        cp !== "" &&
        //Contacto

        telefono_movil !== "" &&
        correo_electronico !== ""
      ) {
        // Validación CURP antes de enviar
        if (!curpRegex.test(curp)) {
          setMsgError("La CURP ingresada no es válida");
          setIsAlert(true);
          return;
        }
        if (!rfcRegexphysics.test(rfcphysics)) {
          setMsgError("El RFC ingresado no es válido");
          setIsAlert(true);
          return;
        }
        if (!emailRegex.test(correo_electronico)) {
          setMsgError("El correo electronico ingresado no es válido");
          setIsAlert(true);
          return;
        }
// Validaciones de los enlistados
        if (
          id_nacionalidad === 0 ||
          id_nacionalidad === undefined ||
          id_nacionalidad === null ||
          id_nacionalidad === "" ||
          isNaN(id_nacionalidad)
        ) {
          setMsgError("Campo de nacionalidad no seleccionado");
          setIsAlert(true);
          //focusAndHighlight(id_nacionalidadRef);
          return;
        }

        if (
          id_estado === 0 ||
          id_estado === undefined ||
          id_estado === null ||
          id_estado === "" ||
          isNaN(id_estado)
        ) {
          setMsgError("Campo de estado civil no seleccionado");
          setIsAlert(true);
          //focusAndHighlight(id_nacionalidadRef);
          return;
        }

        if (id_estado === 1) {
          if (
            id_regimen === 0 ||
            id_regimen === undefined ||
            id_regimen === null ||
            id_regimen === "" ||
            isNaN(id_regimen)
          ) {
            setMsgError("Campo de régimen civil no seleccionado");
            setIsAlert(true);
            //focusAndHighlight(id_nacionalidadRef);
            return;
          }
        }

        if (
          id_pais === 0 ||
          id_pais === undefined ||
          id_pais === null ||
          id_pais === "" ||
          isNaN(id_pais)
        ) {
          setMsgError("Campo de país no seleccionado");
          setIsAlert(true);
          //focusAndHighlight(id_nacionalidadRef);
          return;
        }

        //Validaciones de las vigencias de los archivos

        const archivosSinFecha = archive.filter(
          (fileName) => !fechas[fileName]
        );
        if (archivosSinFecha.length > 0) {
          setMsgError("Algunos o todos los campos de vigencia están vacíos");
          setIsAlert(true);

          //focusAndHighlight(archivo_fecharef);
          return;
        }
//Se crea un objeto que se subira al backend
        const data = {
          id_user: id_user,
          // data - persona fisica
          eltypeofclient: selectedOption,
          elnombre: nombre,
          elap_paterno: ap_paterno,
          elap_materno: ap_materno,
          eltambien_conocido: tambien_conocido,
          elid_nacionalidad: id_nacionalidad,
          ellugar_nacimiento: lugar_nacimiento,
          elfecha_nacimiento: fecha_nacimiento,
          elocupacion: ocupacion,
          elcurp: curp,
          elrfc: rfcphysics,
          elid_estado: id_estado,
          elid_regimen: id_regimen,
          elid_regimen_fiscal: id_regimen_fiscal,

          // data - domicilio

          elcalle: calle,
          elno_exterior: no_exterior,
          elno_interior: no_interior,
          elcolonia: colonia,
          ellocalidad: localidad,
          elciudad: ciudad,
          elestado: estado,
          elpais: id_pais,
          elcp: cp,

          // data - contacto

          eltelefono_particular: telefono_particular,
          eltelefono_oficina: telefono_oficina,
          eltelefono_movil: telefono_movil,
          elcorreo_electronico: correo_electronico,
          elobservaciones_generales: observaciones_generales,

          archivos: archive.map((fileName) => ({
            nombre: fileName,
            fecha: fechas[fileName] || null,
          })),
        };
        setLoading(true);

        try {
          
          console.log("se envio:" + data)
          const res = await axios.post(urlPhp, data);

          //setIsAlert2(true);

          if (res.data > 0) {
            setIsAlert2(true);
            if (abrirNuevo === true) {
              if (boolAdquiriente) {
                agregarAdquiriente({ ...data, id_cliente: res.data});
              }
              if (boolOtorgante) {
                agregarOtorgante({ ... data, id_cliente: res.data });
              }
              //setAbrirBuscar(false);
            }
          }

          console.log(res)

          //alert("Cliente creado correctamente");
          //console.log(res.data);
          //window.location.reload();
        } catch (error) {
          console.error("Error al enviar los datos: ", error);
        }
      } else {
        setIsAlert(true);
      }
    } else { // si es 2 sera persona moral
      const validationMsg = validateData();

      if (validationMsg !== "") {
        setIsAlert(true);
        setMsgError(validationMsg);
        return; // No enviar si hay errores
      }
      if (
        razon_social !== "" &&
        representante_legal !== "" &&
        rfc_moral !== "" &&
        //Domicilio
        calle !== "" &&
        no_exterior !== "" &&
        colonia !== "" &&
        localidad !== "" &&
        ciudad !== "" &&
        id_pais !== 0 &&
        estado !== "" &&
        cp !== "" &&
        //Contacto

        telefono_movil !== "" &&
        correo_electronico !== ""
      ) {
        if (!rfcRegexlegalentity.test(rfc_moral)) {
          setMsgError("El RFC ingresado no es válido");
          setIsAlert(true);
          return;
        }

        if (
          id_pais === 0 ||
          id_pais === undefined ||
          id_pais === null ||
          id_pais === "" ||
          isNaN(id_pais)
        ) {
          setMsgError("Campo de país no seleccionado");
          setIsAlert(true);
          //focusAndHighlight(id_nacionalidadRef);
          return;
        }

        const archivosSinFecha = archive.filter(
          (fileName) => !fechas[fileName]
        );
        if (archivosSinFecha.length > 0) {
          setMsgError("Algunos o todos los campos de vigencia están vacíos");
          setIsAlert(true);
          //focusAndHighlight(archivo_fecharef);
          return;
        }

        const data = {
          id_user: id_user,
          eltypeofclient: selectedOption,
          elrazon_social: razon_social,
          elrepresentante_legal: representante_legal,
          rfc: rfc_moral,
          elid_regimen_fiscal: id_regimen_fiscal,

          // data - domicilio

          elcalle: calle,
          elno_exterior: no_exterior,
          elno_interior: no_interior,
          elcolonia: colonia,
          ellocalidad: localidad,
          elciudad: ciudad,
          elestado: estado,
          elpais: id_pais,
          elcp: cp,

          // data - contacto

          eltelefono_particular: telefono_particular,
          eltelefono_oficina: telefono_oficina,
          eltelefono_movil: telefono_movil,
          elcorreo_electronico: correo_electronico,
          elobservaciones_generales: observaciones_generales,

          archivos: archive.map((fileName) => ({
            nombre: fileName,
            fecha: fechas[fileName] || null,
          })),
        };
        setLoading(true);
        try {
          //console.log("JSON que se va a enviar:",JSON.stringify(data, null, 2));
          const res = await axios.post(urlPhp, data);
          // alert("Cliente creado correctamente");
          if (res.data > 0) {
            setIsAlert2(true);
            if (abrirNuevo === true) {
              if (boolAdquiriente) {
                agregarAdquiriente(data);
              }
              if (boolOtorgante) {
                agregarOtorgante(data);
              }
              //setAbrirBuscar(false);
            }
          }

          //console.log("datos regresados", res)
        } catch (error) {
          console.error("Error al enviar los datos (Persona moral): ", error);
        }
      } else {
        setIsAlert(true);
      }
    }
  };

  // ------------------------------------------------------------------------------------------------------

  // Estos useEffect son para obtener las diferentes opciones de los enlistados

  useEffect(() => {
    
    const getnacionalidad = async () => {
      try {
        const res = await axios.get(id_nacionalidadPhp);
        setnacionalidades(res.data);
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getnacionalidad();
  }, []);

  useEffect(() => {
    const getestado = async () => {
      try {
        const res = await axios.get(id_estadoPhp);
        setestados(res.data);
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getestado();
  }, []);

  useEffect(() => {
    const getregimen = async () => {
      try {
        const res = await axios.get(id_regimenPhp);
        setregimenes(res.data);
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getregimen();
  }, []);

  useEffect(() => {
    const getregimen_fiscal = async () => {
      try {
        const res = await axios.get(id_regimen_fiscalPhp);
        setregimenes_fiscales(res.data);
      } catch (error) {
        console.error("No se hizo la conexion", error);
      }
    };
    getregimen_fiscal();
  }, []);

  useEffect(() => {
    const getlista_pais = async () => {
      try {
        const res = await axios.get(id_lista_paisPhp);
        setPaises(res.data);
      } catch (error) {
        console.error("No se hizo la conexión con la lista de paises", error);
      }
    };
    getlista_pais();
  }, []);

  // -----------------------------------------------------------------------------------------------

  return (
    <>
      <hr />
      {isAlert2 ? (
        <>
          {abrirNuevo ? (
            <>
              <Alerts
                isShow={isAlert2}
                variant="success"
                head="Aviso"
                msg="Cliente creado correctamente"
                clicked={() => {setAbrirNuevo(false); cerrar_Modal();}}
                textButton="OK"
              />
            </>
          ) : (
            <>
              <Alerts
                isShow={isAlert2}
                variant="success"
                head="Aviso"
                msg="Cliente creado correctamente"
                clicked={() => setIsCreated(true)}
                textButton="OK"
              />
            </>
          )}
        </>
      ) : (
        <div className="container-fluid">
          <h5 className="mt-3">
            Creaci&oacute;n de un cliente persona f&iacute;sica
          </h5>
          <p>
            Para crear un nuevo cliente persona f&iacute;sica, deber&aacute; de
            completar los campos requeridos en este formulario, los campos
            marcados son obligatorios, al finalizar el llenado presionar el
            bot&oacute;n de "Registrar Cliente".
          </p>

          <div>
            <label
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <input
                type="radio"
                name="option"
                value="1"
                onChange={(e) => setSelectedOption(e.target.value)}
                checked={selectedOption === "1"}
              />
              Persona física
            </label>
          </div>

          <div>
            <label
              style={{ display: "flex", alignItems: "center", gap: "10px" }}
            >
              <input
                type="radio"
                name="option"
                value="2"
                onChange={(e) => setSelectedOption(e.target.value)}
                checked={selectedOption === "2"}
              />
              Persona moral
            </label>
          </div>

          {selectedOption === "1" && (
            <div className=" mt-4">
              <MDBRow>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Nombre(s)"
                      type="text"
                      value={nombre}
                      onChange={(e) => handleInputChange(e, "nombre")}
                      ref={nombreRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Apellido paterno"
                      type="text"
                      value={ap_paterno}
                      onChange={(e) => handleInputChange(e, "ap_paterno")}
                      ref={ap_paternoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Apellido materno"
                      type="text"
                      value={ap_materno}
                      onChange={(e) => handleInputChange(e, "ap_materno")}
                      ref={ap_maternoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="También conocido como"
                      type="text"
                      value={tambien_conocido}
                      onChange={(e) => handleInputChange(e, "tambien_conocido")}
                      ref={tambien_conocidoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    onChange={handleChangeid_nacionalidad}
                    value={id_nacionalidad}
                    ref={id_nacionalidadRef}
                  >
                    <option value="" key={0}>
                      Selecciona la nacionalidad
                    </option>
                    {nacionalidades.map((nacionalidades) => (
                      <option
                        key={nacionalidades.id_nacionalidad}
                        value={nacionalidades.id_nacionalidad}
                      >
                        {nacionalidades.nacionalidad}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
                <MDBCol>
                  <DatePicker
                    selected={
                      fecha_nacimiento
                        ? (() => {
                            const parts = fecha_nacimiento.split("-");
                            return new Date(parts[0], parts[1] - 1, parts[2]);
                          })()
                        : null
                    }
                    onChange={(date) => {
                      /* console.log("Objeto Date que llega:", date);
                      console.log("getFullYear():", date.getFullYear());
                      console.log("getMonth() + 1:", date.getMonth() + 1);
                      console.log("getDate():", date.getDate());
                      console.log("toISOString():", date.toISOString());
                      console.log(
                        "toISOString().split('T')[0]:",
                        date.toISOString().split("T")[0]
                      ); */

                      setfecha_nacimiento(date.toISOString().split("T")[0]);
                    }}
                    dateFormat="yyyy-MM-dd"
                    placeholderText="Selecciona tu fecha de nacimiento"
                    className="form-control"
                    wrapperClassName="w-100"
                    showYearDropdown
                    scrollableYearDropdown
                    yearDropdownItemNumber={100}
                    //ref={customInputRef}
                    customInput={<CustomDateInput />}
                  />
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Lugar de nacimiento"
                      type="text"
                      value={lugar_nacimiento}
                      onChange={(e) => handleInputChange(e, "lugar_nacimiento")}
                      ref={lugar_nacimientoRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Ocupaci&oacute;n"
                      type="text"
                      value={ocupacion}
                      onChange={(e) => handleInputChange(e, "ocupacion")}
                      ref={ocupacionRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="C.U.R.P."
                      type="text"
                      value={curp}
                      onChange={(e) => handleInputChange(e, "curp")}
                      ref={curpRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label=/*"R.F.C."*/"R.F.C"
                      type="text"
                      value={rfcphysics}
                      onChange={(e) => handleInputChange(e, "rfc")}
                      ref={rfcRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>
             
              <MDBRow className="mt-3">
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    onChange={handleChangeid_estado}
                    value={id_estado}
                    ref={id_estadoRef}
                  >
                    <option value="" key={0}>
                      Selecciona el estado civil
                    </option>
                    {estados.map((estados) => (
                      <option key={estados.id_estado} value={estados.id_estado}>
                        {estados.estado}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    onChange={handleChangeid_regimen}
                    value={id_regimen}
                    disabled={Number(id_estado) !== 1}
                    ref={id_regimenRef}
                  >
                    <option value="" key={0}>
                      Selecciona el régimen matrimonial
                    </option>
                    {regimenes.map((regimenes) => (
                      <option
                        key={regimenes.id_regimen}
                        value={regimenes.id_regimen}
                      >
                        {regimenes.regimen}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
              </MDBRow>
              <MDBRow className="mt-3">
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    onChange={handleChangeid_regimen_fiscal}
                    value={id_regimen_fiscal}
                  >
                    <option value="" key={0}>
                      Selecciona el r&eacute;gimen fiscal
                    </option>
                    {regimenes_fiscales.map((regimenes_fiscales) => (
                      <option
                        key={regimenes_fiscales.id_regimen_fiscal}
                        value={regimenes_fiscales.id_regimen_fiscal}
                      >
                        {regimenes_fiscales.regimen_fiscal}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
              </MDBRow>
            </div>
          )}

          {selectedOption === "2" && (
            <div className="mt-4">
              <MDBRow>
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Razón social"
                      type="text"
                      value={razon_social}
                      onChange={(e) => handleInputChange(e, "razon_social")}
                      ref={razon_socialRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="Representante legal"
                      type="text"
                      value={representante_legal}
                      onChange={(e) =>
                        handleInputChange(e, "representante_legal")
                      }
                      ref={representante_legalRef}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>

                <MDBCol>
                  <div style={{ position: "relative", width: "100%" }}>
                    <MDBInput
                      label="RFC"
                      type="text"
                      value={rfc_moral}
                      ref={rfc_moralRef}
                      onChange={(e) => handleInputChange(e, "rfc_moral")}
                    />
                    <span
                      style={{
                        position: "absolute",
                        bottom: "8px",
                        right: "12px",
                        color: "red",
                        fontWeight: "bold",
                        pointerEvents: "none",
                      }}
                    >
                      *
                    </span>
                  </div>
                </MDBCol>
              </MDBRow>

              <MDBRow className="mt-3">
                <MDBCol>
                  <Form.Select
                    className="form-select"
                    onChange={handleChangeid_regimen_fiscal}
                    value={id_regimen_fiscal}
                  >
                    <option value="" key={0}>
                      Selecciona el régimen fiscal
                    </option>
                    {regimenes_fiscales.map((regimen) => (
                      <option
                        key={regimen.id_regimen_fiscal}
                        value={regimen.id_regimen_fiscal}
                      >
                        {regimen.regimen_fiscal}
                      </option>
                    ))}
                  </Form.Select>
                </MDBCol>
              </MDBRow>
            </div>
          )}

          {/*Formulario de datos de domicilio */}
          <div className="fieldset-container">
            <span className="fieldset-title">Domicilio</span>

            <MDBRow className="mt-3">
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="Calle"
                    type="text"
                    value={calle}
                    ref={calleRef}
                    onChange={(e) => handleInputChange(e, "calle")}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="No. Exterior"
                    type="text"
                    value={no_exterior}
                    ref={no_exteriorRef}
                    onChange={(e) => {
                      handleInputChange(
                        { target: { value: e.target.value } },
                        "no_exterior"
                      );
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
              <MDBCol>
                <MDBInput
                  label="No. Interior"
                  type="text"
                  value={no_interior}
                  onChange={(e) => {
                    handleInputChange(
                      { target: { value: e.target.value } },
                      "no_interior"
                    );
                  }}
                />
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="Colonia"
                    type="text"
                    value={colonia}
                    ref={coloniaRef}
                    onChange={(e) => handleInputChange(e, "colonia")}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="Localidad"
                    type="text"
                    value={localidad}
                    ref={localidadRef}
                    onChange={(e) => handleInputChange(e, "localidad")}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="Ciudad"
                    type="text"
                    value={ciudad}
                    ref={ciudadRef}
                    onChange={(e) => handleInputChange(e, "ciudad")}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="Estado"
                    type="text"
                    value={estado}
                    ref={estadoRef}
                    onChange={(e) => handleInputChange(e, "estado")}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
              <MDBCol>
                <Form.Select
                  className="form-select"
                  value={id_pais}
                  ref={id_paisRef}
                  onChange={handleChangePais}
                >
                  <option value="" key={0}>
                    Selecciona tu país
                  </option>
                  {paises.map((p) => (
                    <option key={p.id_pais} value={p.id_pais}>
                      {p.pais}
                    </option>
                  ))}
                </Form.Select>
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="CP"
                    type="text"
                    value={cp}
                    ref={cpRef}
                    onChange={(e) => {
                      //Solo números
                      //const onlyNumbers = e.target.value.replace(/\D/g, "");
                      handleInputChange(
                        { target: { value: e.target.value } },
                        "cp"
                      );
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
            </MDBRow>
          </div>

          {/*Formulario de datos de contacto*/}

          <div className="fieldset-container">
            <span className="fieldset-title">Contacto</span>

            <MDBRow className="mt-3">
              <MDBCol>
                <MDBInput
                  label="Teléfono particular"
                  type="text"
                  value={telefono_particular}
                  onChange={(e) => {
                    //const onlyNumbers = e.target.value.replace(/[^\d+\-()\s]/g, "");
                    handleInputChange(
                      { target: { value: e.target.value } },
                      //{ target: { value: onlyNumbers } },
                      "telefono_particular"
                    );
                  }}
                />
              </MDBCol>
              <MDBCol>
                <MDBInput
                  label="Teléfono oficina"
                  type="text"
                  value={telefono_oficina}
                  onChange={(e) => {
                    //const onlyNumbers = e.target.value.replace(/\D/g, "");
                    handleInputChange(
                      { target: { value: e.target.value } },
                      //{ target: { value: onlyNumbers } },
                      "telefono_oficina"
                    );
                  }}
                />
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="Teléfono móvil"
                    type="text"
                    ref={telefono_movilRef}
                    value={telefono_movil}
                    onChange={(e) => {
                      //const onlyNumbers = e.target.value.replace(/\D/g, "");
                      handleInputChange(
                        { target: { value: e.target.value } },
                        //{ target: { value: onlyNumbers } },
                        "telefono_movil"
                      );
                    }}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
              <MDBCol>
                <div style={{ position: "relative", width: "100%" }}>
                  <MDBInput
                    label="Correo electronico"
                    type="text"
                    ref={correo_electronicoRef}
                    value={correo_electronico}
                    onChange={(e) => handleInputChange(e, "correo_electronico")}
                  />
                  <span
                    style={{
                      position: "absolute",
                      bottom: "8px",
                      right: "12px",
                      color: "red",
                      fontWeight: "bold",
                      pointerEvents: "none",
                    }}
                  >
                    *
                  </span>
                </div>
              </MDBCol>
            </MDBRow>

            <MDBRow className="mt-3">
              <MDBCol>
                <MDBTextArea
                  label="Observaciones generales"
                  value={observaciones_generales}
                  onChange={(e) =>
                    handleInputChange(e, "observaciones_generales")
                  }
                />
              </MDBCol>
            </MDBRow>
          </div>

          {/*Archivos */}
          <div className="fieldset-container">
            <span className="fieldset-title">Archivos</span>

            <div>
              {archive.map((fileName, index) => (
                <div
                  key={index}
                  className="border p-2 m-2 flex items-center gap-2"
                >
                  <MDBRow>
                    <MDBCol size="auto">
                      <button
                        type="button"
                        className="p-0 border-0 bg-transparent"
                        onClick={() => delete_files(fileName)}
                      >
                        <img
                          src={tache}
                          width="40px"
                          height="25px"
                          alt="icono"
                        ></img>
                      </button>
                    </MDBCol>
                    <MDBCol>
                      <p className="m-0">{fileName}</p>
                    </MDBCol>
                    <MDBCol>
                      <MDBInput
                        label="Captura la vigencia en número de meses"
                        type="number"
                        value={fechas[fileName] || ""}
                        ref={archivo_fecharef}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => {
                          const months = parseInt(e.target.value || 0, 10);
                          setFechas((prev) => ({
                            ...prev,
                            [fileName]: months,
                          }));
                        }}
                      />
                    </MDBCol>
                  </MDBRow>
                </div>
              ))}
            </div>

            {showModal &&
              ReactDOM.createPortal(
                <div className="modal show d-block">
                  {" "}
                  {/* ocupa el 80% del alto */}
                  <div
                    className="modal-body"
                    style={{ fontSize: "30px" }}
                    dangerouslySetInnerHTML={{ __html: modalHTML }}
                  />
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={handleCloseModal}
                    >
                      Cerrar
                    </button>
                  </div>
                </div>,
                document.body
              )}

            <div className="d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-primary mb-2 "
                onClick={handleOpenModal}
              >
                Subir Archivos
              </button>
            </div>
          </div>

          <MDBRow className="mt-4">
            {(isAlert || msgError !== "") && (
              <Alerts
                isShow={isAlert || msgError !== ""}
                variant="danger"
                head="Error de Registro"
                msg={msgError}
                clicked={() => {
                  setIsAlert(false);
                  const ref = getRefFromError();
                  focusAndHighlight(ref);
                  const refdate = getRefFromErrordate();
                  focusAndHighlightdate(refdate);
                  setMsgError("");
                }}
                textButton="OK"
                variantButton="outline-danger"
              />
            )}
          </MDBRow>

          <MDBRow className="d-flex justify-content-between align-items-center my-4">
            {abrirNuevo ? (
              <>
                <MDBCol className="col-auto">
                  <button
                    className="btn btn-warning"
                    onClick={() => cerrar_Modal()}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⟵
                  </button>
                </MDBCol>
              </>
            ) : (
              <>
                <MDBCol className="col-auto">
                  <button
                    className="btn btn-warning"
                    onClick={() => window.location.reload()}
                    style={{
                      borderRadius: "8px",
                      fontWeight: "bold",
                    }}
                  >
                    ⟵
                  </button>
                </MDBCol>
              </>
            )}

            <MDBCol className="col-auto">
              <button className="btn btn-primary" disabled= {loading} onClick={handleSubmitData}>
                Registrar Cliente
              </button>
            </MDBCol>
          </MDBRow>
        </div>
      )}
    </>
  );
};

export default New;
